import { Button, createStyles, makeStyles, Slide, TextField, Theme, Typography } from "@material-ui/core";
import { API, graphqlOperation } from "aws-amplify";
import React, { useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import translate from "../../../i18n/translate";
import { SetLearnerInfoPeople } from "../../../queries";
import allActions from "../../../redux/actions";
import Toaster from "../../shared/Toaster/Toaster";
import "./ManagerEmailPage.scss";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
        borderColor: "#42BABD",
      },
    },
    continueButton: {
      width: "533px",
      margin: "15px auto",
      height: "60px",
    },
  })
);

const ManagerEmailPage = () => {
  const dispatch = useDispatch();
  const allInfo = useSelector((state: any) => state);
  const classes = useStyles();
  let [managerEmailID, setmanagerEmailID] = useState("");
  let [isManagerEmailValid, setisManagerEmailValid] = useState(false);
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });
  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };
  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };
  const validateManagerEmail = (e: any) => {
    if (e.target.checkValidity()) {
      setisManagerEmailValid(true);
    } else {
      setisManagerEmailValid(false);
    }
  };
  const handleEmailUpdate = () => {
    let pInfo = JSON.parse(sessionStorage.getItem("pInfo") || JSON.stringify(allInfo.peopleInformation));
    pInfo.data.getpeopleInformation["managerEmailID"] = managerEmailID;
    let peopleResponse = pInfo.data.getpeopleInformation;
    peopleResponse.managerEmail = managerEmailID;
    const poepleData = API.graphql(
      graphqlOperation(
        SetLearnerInfoPeople(`${sessionStorage.getItem("lgId")}`, peopleResponse, peopleResponse.language)
      )
    ) as Promise<any>;    
    poepleData.then(async (resp1) => {
      await dispatch(allActions.peopleInformationActions.getStorePeopleInfo(sessionStorage.getItem("lgId") || "0000"));
      sessionStorage.setItem("managerEmail", managerEmailID);
      dispatch(allActions.commonActions.setManagerEmail(managerEmailID));
      dispatch(allActions.commonActions.setManagerEmailRequired(false));
      if (sessionStorage.getItem("urlRedirect") !== null) {
        window.location.href = `${window.location.protocol}//${window.location.host}${sessionStorage.getItem("urlRedirect")}`;
      }
    });
  };
  return (
    <div className="manager-email-container">
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />
      <div className="manager-profile-container">
        <div className="manager-profile-form-container">
          {
            <div className="manager-form-row">
              <div className="manager-form-input">
                <Typography className="manager-text">{translate("manager_email_managertext")}</Typography>
              </div>
              <div className="manager-form-input">
                <div className="input_row">
                  <div className="input_100 textFieldNoBorderRadius">
                    <TextField
                      id="manager_email"
                      autoComplete="off"
                      value={managerEmailID}
                      name="manager_email"
                      variant="outlined"
                      type="email"
                      fullWidth={true}
                      label={translate("profile_managerEmailpopupPlaceholder")}
                      required={true}
                      onChange={(e) => {
                        setmanagerEmailID(e.target.value);
                        validateManagerEmail(e);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          <Button
            variant="contained"
            size="large"
            color="primary"
            className={classes.continueButton}
            disabled={!isManagerEmailValid}
            onClick={handleEmailUpdate}
          >
            {translate("SessionRating_submit")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ManagerEmailPage;
